import React from 'react';

import Paper from '@material-ui/core/Paper';

import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CustomerViewContents from './customer_view_contents';
import { ReactComponent as Vectors } from '../../images/Vectors.svg';

const styles = (theme) => ({
  paper: {
    padding: theme.spacing(5),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(5),
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    maxWidth: '1000px',
  },
  linkRow: {
    margin: theme.spacing(5),
  },
  backgroundDivStyle: {
    backgroundColor: theme.palette.primary.main,
    height: '350px',
    right: '0px',
    left: '0px',
    position: 'absolute',
    zIndex: '-1',
  },
  vectors: {
    position: 'absolute',
    left: '0px',
    right: '0px',
    bottom: '0px',
  },
});

class CustomerViewQuotePage extends React.Component {
  // constructor(props) {
  //     super(props);
  // }

  render() {
    const { classes, ...otherProps } = this.props;
    return (
      <Grid container spacing={0}>
        <div className={classes.backgroundDivStyle}>
          <Vectors className={classes.vectors} />
        </div>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <Paper className={classes.paper}>
              <CustomerViewContents {...otherProps} />
            </Paper>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.linkRow}>
          <Grid container justifyContent="center">
            <a rel="noopener noreferrer" target="_blank" href="https://www.freightlegend.com/">
              Powered by FreightLegend
            </a>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

CustomerViewQuotePage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles, { withTheme: true }))(CustomerViewQuotePage);
